// extracted by mini-css-extract-plugin
export default {"errorView":"styles_errorView__1CrvJ"};